import { NgModule } from '@angular/core';
import { APP_ROUTES } from './app.routing';
import { NxiConfigUtil } from '@pershing/nxi-common';
import { PathManipulation } from '../utils/path_manipulation';
import { PageAssemblyModule, SiteConfigOptions, SITE_CONFIG_OPTIONS } from '@pershing/nxd-page-assembly-core';
import { MenuConfigOptions, MENU_CONFIG_OPTIONS } from '@pershing/nxi-core';
import { EditLibraryModule, EDIT_LIBRARY_OPTIONS, EditLibraryOptions } from '@pershing/pershing-page-edit-library';
export const COMMON_ROUTES = [
    APP_ROUTES
];
let siteConfigServiceFactory = function (appSettings: any)  {
    console.log(location.hostname);
    let host = location.host;
    var hostUrl = host.split(":");
    var portNum = hostUrl[1];
    var hostNameLocal = hostUrl[0];
    let entBaseUrl: string;
    let baseConfigSource: string;
    let customConfigSource: string;
    const name = '@pershing/nxi-ng-portal-common';
    if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
        baseConfigSource  = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/site-config.json';
        entBaseUrl = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/component-entitlements.json'; 
    }else {
        baseConfigSource = 'lib/assets/site-config.json';
        entBaseUrl = 'lib/assets/component-entitlements.json';
    
    }
    let siteConfigoptions: SiteConfigOptions = new SiteConfigOptions();
    siteConfigoptions.componentEntitlementURL = entBaseUrl;
    let communityName = NxiConfigUtil.getCommunityName(appSettings);
    if (appSettings.isModernTheme) {
        if(hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
        baseConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/modern/site-config.json';
        }else {
            baseConfigSource = 'lib/assets/modern/site-config.json';
        }
    }
    if (appSettings.themeType !== undefined && appSettings.themeType === 'ada') {
        if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
            baseConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/site-config-ada.json';
        }else {
            baseConfigSource = 'lib/assets/site-config-ada.json';
        }
       
        if (appSettings.isModernTheme) {
            if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
                baseConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/modern/site-config-ada.json';
            }else {
                baseConfigSource = 'lib/assets/modern/site-config-ada.json';
            }
        }
        if (communityName !== 'netxinvestor') {
            let fomattedCommunity = communityName;
            if (communityName.includes('ada-')) {
                fomattedCommunity = communityName.split('ada-')[1];
            }
            if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
                customConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/site-config-ada-' + fomattedCommunity + '.json';
            }else {
                customConfigSource = 'lib/assets/site-config-ada-' + fomattedCommunity + '.json';
            }
            if (appSettings.isModernTheme) {
                if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
                    customConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/modern/site-config-ada-' + fomattedCommunity + '.json';
                }else {
                    customConfigSource = 'lib/assets/modern/site-config-ada-' + fomattedCommunity + '.json';
                }
            }
            siteConfigoptions.customConfigURL = customConfigSource;
        }
    }
    siteConfigoptions.baseConfigURL = baseConfigSource;
    // to not display Page Not Configured message
    siteConfigoptions.pageNotConfiguredMessage = '';
    if (communityName !== 'netxinvestor') {
        if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
         customConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/site-config-' + communityName + '.json';
        } else {
            customConfigSource = 'lib/assets/site-config-' + communityName + '.json';
        }
        if (appSettings.isModernTheme) {
            if (hostNameLocal =='localhost' || portNum == '9995' || portNum== '9999') {
            customConfigSource = 'node_modules/@pershing/nxi-ng-portal-common/lib/assets/modern/site-config-' + communityName + '.json';
            } else {
                customConfigSource = 'lib/assets/modern/site-config-' + communityName + '.json';
            }
        }
        if (!siteConfigoptions.customConfigURL) {
            siteConfigoptions.customConfigURL = customConfigSource;
        }
    }

    let basePath = PathManipulation.getBasePath(appSettings);

    if (basePath != null) {
        siteConfigoptions.baseConfigURL = basePath + '/' + siteConfigoptions.baseConfigURL;
        if (siteConfigoptions.customConfigURL) {
            siteConfigoptions.customConfigURL = basePath + '/' + siteConfigoptions.customConfigURL;
        }
        siteConfigoptions.componentEntitlementURL = basePath + '/' + siteConfigoptions.componentEntitlementURL;
    }

    if (appSettings.cacheBust && appSettings.cacheBust.length > 0) {
        siteConfigoptions.baseConfigURL = siteConfigoptions.baseConfigURL + '?' + appSettings.cacheBust;
        if (siteConfigoptions.customConfigURL) {
            siteConfigoptions.customConfigURL = siteConfigoptions.customConfigURL + '?' + appSettings.cacheBust;
        }
        siteConfigoptions.componentEntitlementURL = siteConfigoptions.componentEntitlementURL + '?' + appSettings.cacheBust;
    }

    if (appSettings.isSitebuilder && appSettings.site_config_hierarchy) {
        siteConfigoptions.baseConfigURL = appSettings.site_config_hierarchy.baseConfigURL;
        siteConfigoptions.customConfigURL = appSettings.site_config_hierarchy.customConfigURL;
    }
    return siteConfigoptions;
};

let menuConfigServiceFactory = function (appSettings: any) {
    const name = '@pershing/nxi-ng-portal-common';
    let menuConfigoptions: MenuConfigOptions = new MenuConfigOptions();
    let basePath = PathManipulation.getBasePath(appSettings);
    if (basePath != null) {
        menuConfigoptions.basePath = basePath + '/';
    }
    return menuConfigoptions;
};

let editLibraryServiceFactory = () => {
    let config: EditLibraryOptions = new EditLibraryOptions();
    config.allowDuplicateComponents = true;
    return config;
};
/**
 * @dynamic
 */
@NgModule({
    imports: [
        COMMON_ROUTES,
        PageAssemblyModule.forRoot(),
        EditLibraryModule
    ],
    providers: [
        { provide: SITE_CONFIG_OPTIONS, useFactory: siteConfigServiceFactory, deps: ['AppSettings'] },
        { provide: MENU_CONFIG_OPTIONS, useFactory: menuConfigServiceFactory, deps: ['AppSettings'] },
        { provide: EDIT_LIBRARY_OPTIONS, useFactory: editLibraryServiceFactory, deps: ['AppSettings'] }
    ]
})

export class PortalRoutingModule { }
